import { apiClient } from '../http'

export const gameService = {
    // Задания
    tasks: {
        async getTasks() {
            const response = await apiClient.get('/tasks')
            return response.data
        },

        async claimTask(taskId) {
            const response = await apiClient.post(`/tasks/${taskId}/claim`)
            return response.data
        },
    },

    // Друзья
    friends: {
        async getFriends() {
            const response = await apiClient.get('/friends')
            return response.data
        },

        async getReferralCode() {
            const response = await apiClient.get('/friends/referral-code')
            return response.data
        },
    },

    // Кейсы
    cases: {
        async getCases(category) {
            const params = category ? { category } : {}
            const response = await apiClient.get('/cases', { params })
            return response.data
        },

        async openCase(caseId, game) {
            const body = game ? { game } : {}
            const response = await apiClient.post(`/cases/${caseId}/open`, body)
            return response.data
        },

        async getInventory() {
            const response = await apiClient.get('/cases/inventory')
            return response.data
        },
    },

    // Адвент календарь
    advent: {
        async getCalendar() {
            const response = await apiClient.get('/advent')
            return response.data
        },

        async claimDay(day) {
            const response = await apiClient.post(`/advent/${day}/claim`)
            return response.data
        },
    },
}
